import React from 'react';
import { Button, Icon } from 'semantic-ui-react';

import iframe from '../../dashboard-routes/Iframe/iframeData';
import CaseProgress from './CaseProgress';
import Modal from '../../shared/Modal';
import AddEditStore from './Store';
import * as api from '../../../stores/api';

function ModalCaseProgress() {
  const openCaseCorrespondence = () => {
    const {
      toggleModal,
      modalParams: { id },
    } = AddEditStore;

    const caseNo = `Case A-${(id + '').padStart(6, 0)}`;
    localStorage.setItem('PostAssessment', caseNo);
    iframe.forceOpenTab('PostAssessment', `?id=${id}&view=PostAssessment#Corespondence`, {
      id,
      view: 'PostAssessment',
    });

    toggleModal(false)();
  };

  const { open, assessmentInfo, toggleModal } = AddEditStore;
  const title = `Status History: ${assessmentInfo.AssessmentNumber}`;
  const url = '/MedicalService/GetAssessmentLogs';
  const body = { assessmentId: assessmentInfo.Id };

  return (
    <Modal
      visible={open}
      onCancel={toggleModal(false)}
      width={1700}
      title={title}
      footer={
        <React.Fragment>
          {!api.isTypist() && (
            <Button color="blue" onClick={openCaseCorrespondence}>
              <Icon name="table" /> View Case Correspondence
            </Button>
          )}
          <Button color="red" onClick={toggleModal(false)}>
            <Icon name="close" /> Close
          </Button>
        </React.Fragment>
      }
    >
      <CaseProgress progressList={api.IME_CaseProgress.data.itemList} url={url} body={body} showHistory />
    </Modal>
  );
}

export default ModalCaseProgress;
